"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ADD_LANG = exports.UPDATE_LANG = void 0;
const react_1 = __importDefault(require("react"));
const schemaComponents_1 = require("@/schemaComponents");
const standard_1 = require("react-hook-schema/standard");
const models_hook_1 = require("app/models.hook");
const route_1 = require("../route");
const schema_1 = __importDefault(require("./schema"));
const auth_1 = require("common/auth");
const index_1 = require("../../../../index");
exports.UPDATE_LANG = route_1.LANG.sub("/edit", Lang);
exports.ADD_LANG = route_1.LANGS.sub("/new", Lang);
function Lang({ langId, projectId }) {
    (0, auth_1.useProjectPageAuthorization)(projectId);
    const { projectRole } = (0, auth_1.useProjectPageAuthorization)(projectId);
    const isMaster = projectRole === "master";
    const { data, loading, set, remove, isEditing } = (0, models_hook_1.useLangDoc)({
        langId,
        projectId,
    });
    const { data: projectData } = (0, models_hook_1.useProjectDoc)({ projectId });
    const parameter = {
        title: isEditing ? "言語詳細" : "言語新規作成",
        schema: (0, schema_1.default)({
            isEditing,
        }),
        edit: {
            title: `${isEditing ? "保存" : "保存"}`,
            confirm: `${isEditing ? "保存" : "保存"}しますか？`,
            handler: set,
            isDisabled: !isMaster,
        },
        remove: isEditing ? { handler: remove } : undefined,
        backPath: (0, index_1.resolveRoute)("LIST_LANGS", { projectId }),
        clipboard: {
            objectType: "lang",
            retainKeys: ["projectId", "langId"],
            isDisabled: !isMaster,
        },
    };
    return (react_1.default.createElement(schemaComponents_1.SchemaFormPage, { data: data, parameter: parameter, loading: isEditing && loading, header: react_1.default.createElement(standard_1.AdminLocaleSelector, { locales: projectData === null || projectData === void 0 ? void 0 : projectData.availableLocales }), editModeEnabled: true }));
}
exports.default = Lang;
